import React from "react"
import PropTypes from "prop-types"
import { Card, Segment, Grid } from "semantic-ui-react"
import { Line } from "react-chartjs-2"
import moment from "moment"
import { withTranslation } from "react-i18next"

const colors = ["#36A2EB", "#D12475", "#22C72D", "#c9d437", "#732280"]

const weekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
]

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const days = []

for (let i = 1; i < 32; i++) {
  days.push(i)
}

const options = {
  legend: {
    display: false,
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
  tooltips: {
    enabled: false,
  },
}

@withTranslation()
export class ShardedAnalyticsCard extends React.Component {
  format = () => {
    const { t } = this.props
    if (this.props.dateType === "weeks") {
      return weekDays.map((el) => t(el))
    } else if (this.props.dateType === "months") {
      return days
    } else if (this.props.dateType === "years") {
      return months.map((el) => t(el))
    } else {
      return []
    }
  }

  render() {
    const { isLoading, titles, data } = this.props
    const chartData = { datasets: [], labels: this.format() }
    data.map((data, i) => {
      return chartData.datasets.push({
        label: titles[i],
        backgroundColor: "rgba(200,200,200,0.1)",
        borderWidth: 2,
        borderColor: colors[i],
        pointBackgroundColor: colors[i],
        pointHoverBorderWidth: 3,
        pointRadius: 3,
        pointHitRadius: 8,
        data: data.map((el) => el.value),
      })
    })
    return (
      <Card fluid centered>
        <Line data={chartData} options={options} redraw={true} />
      </Card>
    )
  }
}

ShardedAnalyticsCard.propTypes = {
  title: PropTypes.string.isRequired,
  unit: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      at: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
  ).isRequired,
  isLoading: PropTypes.bool,
}
